<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>账户</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item">
                <el-input v-model="rid" placeholder="请输入RID(多个用,隔开)" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.code">
                <el-input v-model="code" placeholder="请输入代码" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.name">
                <el-input v-model="name" placeholder="请输入名称" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item">
                <el-input v-model="alias_name" placeholder="请输入别名" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.social_credit_code">
                <el-input
                    v-model="social_credit_code"
                    placeholder="请输入统一社会信用代码"
                    clearable
                    @keyup.enter.native="getList(0, 1)"
                ></el-input>
            </div>
            <div class="main_header_item" v-if="postList.huantong_code">
                <el-input v-model="huantong_code" placeholder="请输入寰通编号" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.sf_code">
                <el-input v-model="sf_code" placeholder="请输入SF_CODE" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.parent_name">
                <el-input v-model="parent_name" placeholder="请输入上级名称" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item">
                <el-select filterable v-model="category_code" placeholder="请选择类别" clearable>
                    <el-option v-for="item in categoryOptions" :key="item.value" :label="item.name" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.type">
                <el-select filterable v-model="type" placeholder="请选择类型" clearable>
                    <el-option v-for="item in typeOptions" :key="item.value" :label="item.name" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.province_rid">
                <el-select v-model="province_rid" placeholder="请选择省份" clearable @change="provinceChange" filterable>
                    <el-option v-for="item in provincesOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.city_rid">
                <el-select v-model="city_name" placeholder="请选择城市" clearable filterable value-key="value" @change="cityChange">
                    <el-option v-for="item in cityOptions" :key="item.value" :label="item.label" :value="item"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.identity_type">
                <vDropdown
                    model_key="identity_type"
                    model_name="请选择身份类型"
                    :model_value_default="identity_type"
                    request_uri="identityTypes"
                    select_value="value"
                    @onDropChange="onDropChange"
                    ref="identity_type_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="channel_type_code"
                    model_name="请选择渠道类型"
                    :model_value_default="channel_type_code"
                    request_uri="dropChannelType"
                    :request_params="{ with_empty: true }"
                    select_value="value"
                    @onDropChange="onDropChange"
                    ref="channel_type_code_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="channel_type_reference"
                    model_name="请选择渠道类型参考"
                    :model_value_default="channel_type_reference"
                    request_uri="dropChannelType"
                    :request_params="{ with_empty: true, reference: true }"
                    select_value="value"
                    @onDropChange="onDropChange"
                    ref="channel_type_reference_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="has_remark"
                    model_name="备注非空"
                    :model_value_default="has_remark"
                    request_uri="yesOrNo"
                    select_value="value"
                    @onDropChange="onDropChange"
                    ref="has_remark_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="confidence"
                    model_name="请选择确信度"
                    :model_value_default="confidence"
                    request_uri="accountConfidence"
                    select_value="value"
                    @onDropChange="onDropChange"
                    ref="confidence_ref"
                ></vDropdown>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="addAcount" icon="el-icon-plus" v-if="postList.addBtn">新增账户</el-button>
                <el-button size="small" plain @click="calcChannelTypeReference()" :loading="btnLoading">重算渠道类型参考</el-button>
                <el-button size="small" plain @click="flushChannelType('flushChannelType')" :loading="btnLoading">刷新到渠道类型</el-button>
                <el-button size="small" plain @click="flushChannelType('flushChannelTypeReference')" :loading="btnLoading"
                    >刷新到渠道类型参考</el-button
                >
                <el-button size="small" plain @click="mergeAccount">账户合并</el-button>
                <el-button size="small" plain @click="show_help()" icon="el-icon-question">帮助信息</el-button>

                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(0, 1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(1)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <crm-upload obj="account"></crm-upload>
                    <!-- 设置子组件 调整列显示隐藏 顺序 -->
                    <draggableList :draggable="draggable" @isErrShow="isErrshow" v-if="postList.setBtn"></draggableList>
                </div>
            </div>

            <div v-show="is_show_help">
                <div class="flex">
                    <span style="color: red; font-size: 13px"
                        >重算渠道类型参考：调用qwen-max填充渠道类型参考。范围(默认：所有渠道类型参考为空且类别含分销渠道的；可选：RID搜索框或复选框；取3者的并集)。如果范围小于等于100条，立即触发；否则，进入任务队列</span
                    >
                </div>
                <div class="flex">
                    <span style="color: red; font-size: 13px"
                        >刷新到渠道类型：将渠道类型参考刷新到渠道类型。范围(默认：所有渠道类型为空的；可选：RID搜索框或复选框；取3者的并集)</span
                    >
                </div>
                <div class="flex">
                    <span style="color: red; font-size: 13px"
                        >刷新到渠道类型参考：将渠道类型刷新到渠道类型参考。范围(默认：所有渠道类型参考为空的；可选：RID搜索框或复选框；取3者的并集)。PS：界面更新渠道类型会自动刷新到渠道类型参考</span
                    >
                </div>
                <div class="flex" v-for="(item, index) in taskQueueMessage" :key="index">
                    <span style="color: red; font-size: 13px">
                        {{ item }}
                    </span>
                </div>
            </div>

            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                @sort-change="changeSort"
                :max-height="this.$tableHeight"
                class="account"
                @header-dragend="changeColWidth"
                @selection-change="handleSelectionChange"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
            >
                <el-table-column type="selection" width="50" align="center"></el-table-column>

                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope">
                            <!-- 上级标签处理 -->
                            <div v-if="item.prop == 'code' || item.prop == 'name' || item.prop == 'parent_name'">
                                <el-link type="primary" @click="handleClick(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="editDetails(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="amend(scope.row.id)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page.sync="page"
                    :page-size="row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize } from '../../../../../js/common.js';
import draggableList from '../../../../common/Drawer.vue';
import crmUpload from '../../../../common/Upload.vue';
export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload
    },
    name: 'accountComponent',
    data() {
        return {
            selected: [],
            is_show_help: false,
            draggable: {
                data_name: 'account'
            },
            down_loading: false,
            btnLoading: false,
            tableData: [],
            colData: [],
            total: 0,
            page: 1,
            row: 25,
            sort: '', //排序参数
            data_name: '', //排序参数
            loading: true,
            code: '', //code
            name: '', // 记录ID
            social_credit_code: '', //统一社会信用代码
            alias_name: '',
            rid: '',
            parent_name: '', //上级名称
            huantong_code: '', //寰通code
            sf_code: '',
            province_rid: '', // 省ID
            identity_type: '', // 身份类型
            channel_type_code: '',
            channel_type_reference: '',
            has_remark: '',
            confidence: '',
            city_rid: '', // 市ID
            city_name: '',
            category_code: '',
            categoryOptions: [],
            type: '', // 类型下拉
            typeOptions: [], //类型
            provincesOptions: [], //省份列表
            cityOptions: [], //城市列表
            parent_rid: '',
            postList1: {},
            taskQueueMessage: []
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    created() {
        this.postList1 = this.postList;
    },
    watch: {
        postList1: {
            handler(newValue, oldValue) {
                if (newValue.params) {
                    if (newValue.params.parent_rid) {
                        this.parent_rid = newValue.params.parent_rid;
                        this.getList(0); //获取列表
                    } else {
                        this.parent_rid = '';
                    }
                }
            },
            deep: true
        }
    },
    beforeMount() {
        //详情内调用不用本地存储的params
        if (!this.postList.params) {
            //列表页面调用 优先取本地存储
            var paramsList = JSON.parse(localStorage.getItem('paramsList'));
            if (paramsList['account_params']) {
                this.page = paramsList['account_params'].page;
                this.row = paramsList['account_params'].row;
                this.name = paramsList['account_params'].name;
                // this.data_name = paramsList['account_params'].data_name;
                // this.sort = paramsList['account_params'].sort;
                this.code = paramsList['account_params'].code;
                this.social_credit_code = paramsList['account_params'].social_credit_code;
                this.alias_name = paramsList['account_params'].alias_name;
                this.rid = paramsList['account_params'].rid;
                this.huantong_code = paramsList['account_params'].huantong_code;
                this.sf_code = paramsList['account_params'].sf_code;
                this.parent_name = paramsList['account_params'].parent_name;
                this.province_rid = paramsList['account_params'].province_rid;
                this.identity_type = paramsList['account_params'].identity_type;
                this.channel_type_code = paramsList['account_params'].channel_type_code;
                this.channel_type_reference = paramsList['account_params'].channel_type_reference;
                this.has_remark = paramsList['account_params'].has_remark;
                this.confidence = paramsList['account_params'].confidence;
                this.city_rid = paramsList['account_params'].city_rid;
                this.city_name = paramsList['account_params'].city_name;
                this.parent_rid = paramsList['account_params'].parent_rid;
                this.type = paramsList['account_params'].type;
                this.category_code = paramsList['account_params'].category_code;
            }
        }
        this.initTaskQueueMessage();
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.row = 10;
            } else {
                this.getCategory();
                this.getType();
                this.getProvinces(); //获取省份
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        handleSelectionChange(val) {
            this.selected = [];
            val.forEach((element) => {
                this.selected.push(element['rid']);
            });
            return true;
        },
        show_help() {
            this.is_show_help = this.is_show_help == false ? true : false;
        },
        initTaskQueueMessage() {
            this.$api['taskQueueMessage']({
                code: ['calc_account_channel_type_reference', 'batch_insert_huantong_account']
            })
                .then((res) => {
                    if (res.code == 0) {
                        this.taskQueueMessage = res.data;
                    }
                })
                .catch((error) => {
                    this.taskQueueMessage = [];
                });
        },
        //子组件更新完毕
        isErrshow(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('account', this, 1);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).account;
        },
        // 重算渠道类型参考
        calcChannelTypeReference() {
            this.$confirm('您确定要重算吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['calcChannelTypeReference']({
                        rids: this.selected,
                        rid: this.rid
                    })
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: res.data,
                                    type: 'success'
                                });
                                this.reload();
                            }
                            this.btnLoading = false;
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        // 刷新到渠道分类[参考]
        flushChannelType(method) {
            this.$confirm('您确定要刷新吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api[method]({
                        rids: this.selected,
                        rid: this.rid
                    })
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '刷新成功',
                                    type: 'success'
                                });
                                this.reload();
                            }
                            this.btnLoading = false;
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        //新增
        addAcount() {
            if (this.postList.params) {
                if (this.postList.params.parent_rid) {
                    this.$router.push({
                        path: '/accountEdit',
                        query: {
                            type: 4,
                            detail_type: this.postList.params.detail_type,
                            detail_type_label: this.postList.params.detail_type_label,
                            parent_name: this.postList.params.partner_name,
                            parent_rid: this.postList.params.parent_rid
                        }
                    });
                }
            } else {
                this.$router.push({
                    path: '/accountEdit',
                    query: {
                        type: 3
                    }
                });
            }
        },
        // 账户合并
        mergeAccount() {
            this.$router.push({
                path: 'accountMergeList',
                query: {}
            });
        },
        //前往编辑页面
        editDetails(id) {
            this.$router.push({
                path: 'accountEdit',
                query: {
                    type: 1,
                    id: id
                }
            });
        },
        //复制页面
        copy(id) {
            this.$router.push({
                path: 'accountEdit',
                query: {
                    type: 5,
                    id: id
                }
            });
        },
        //删除当前行
        amend(id) {
            var params = {
                id: id
            };
            let messages = '删除账户会同时删除账户别名，是否继续?';
            this.$msgbox(messages, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$api
                        .accountDelete(params)
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '删除成功',
                                    type: 'success'
                                });
                                this.getList(0);
                            }
                        })
                        .catch((error) => {});
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },
        //省份改变请求当下省份下的城市
        provinceChange() {
            this.cityOptions = [];
            this.city_rid = '';
            this.city_name = '';
            if (this.province_rid) {
                let params = {
                    parent_rid: this.province_rid
                };
                this.$api
                    .cities(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.cityOptions = [];
                            let data = res.data;
                            data.forEach((value) => {
                                this.cityOptions.push({
                                    value: value.rid,
                                    label: value.name
                                });
                            });
                        }
                    })
                    .catch((error) => {});
            }
        },
        //获取省份
        getProvinces() {
            let params = {
                has_all: '0'
            };
            this.$api
                .provinces(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.provincesOptions = [];
                        let data = res.data;
                        data.forEach((value) => {
                            this.provincesOptions.push({
                                value: value.rid,
                                label: value.name
                            });
                        });
                    }
                })
                .catch((error) => {});
        },
        getCategory() {
            let params = {};
            this.$api
                .accountCategory(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.categoryOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //获取类型
        getType() {
            let params = {};
            this.$api
                .accountType(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.typeOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        // 从后台获取数据,重新排序
        changeSort(val) {
            this.data_name = val.prop;
            if (val.order == 'ascending') {
                this.sort = 'asc';
            } else if (val.order == 'descending') {
                this.sort = 'desc';
            }
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['account_params']) {
                    newParamsList['account_params'].data_name = val.prop;
                    newParamsList['account_params'].sort = this.sort;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            if (this.sort !== '') {
                this.getList(0); //获取列表
            }
        },
        //跳转详情
        handleClick(row, prop) {
            if (prop == 'code' || prop == 'name') {
                if (this.postList.params) {
                    if (this.postList.params.parent_rid) {
                        this.parent_rid = row.rid;
                    }
                }
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: row.rid
                    }
                });
            } else if (prop == 'parent_name') {
                if (this.postList.params) {
                    if (this.postList.params.parent_rid) {
                        this.parent_rid = row.parent_rid;
                    }
                }
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: row.parent_rid
                    }
                });
            }
        },
        cityChange(value) {
            if (value) {
                this.city_name = value.label;
                this.city_rid = value.value;
            } else {
                this.city_name = '';
                this.city_rid = '';
            }
        },
        //获取列表数据
        getList(type_data, type) {
            if (type == 1) {
                this.page = 1;
            }
            var params = {
                page: this.page,
                row: this.row,
                name: this.name,
                code: this.code,
                social_credit_code: this.social_credit_code,
                alias_name: this.alias_name,
                rid: this.rid,
                huantong_code: this.huantong_code,
                sf_code: this.sf_code,
                parent_name: this.parent_name,
                province_rid: this.province_rid,
                identity_type: this.identity_type,
                channel_type_code: this.channel_type_code,
                channel_type_reference: this.channel_type_reference,
                has_remark: this.has_remark,
                confidence: this.confidence,
                city_rid: this.city_rid,
                city_name: this.city_name,
                parent_rid: this.parent_rid,
                category_code: this.category_code,
                type: this.type,
                sort: [this.data_name, this.sort],
                is_export: type_data
            };
            //当点击 或者触发回车事件保存参数
            if (type == 1) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                newParamsList['account_params'] = params;
                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            }
            if (type_data == 0) {
                this.loading = true;
                this.$api
                    .accountLists(params)
                    .then((res) => {
                        this.loading = false;
                        if (res.code == 0) {
                            this.tableData = res.data.data;
                            this.total = res.data.total;
                            //判断当前搜素页面参数是否大于最后一页 大于的话取最后一页的参数存起来并用最后一页的参数请求
                            if (res.data.current_page > res.data.last_page) {
                                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                                newParamsList['account_params'].page = res.data.last_page;
                                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                                this.page = res.data.last_page;
                            }
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                    });
            } else {
                this.down_loading = true;
                params.page = 1;
                this.$api
                    .accountListsDownFile(params)
                    .then((res) => {
                        this.$message({
                            message: '下载成功!',
                            type: 'success'
                        });
                        this.down_loading = false;
                    })
                    .catch((error) => {
                        this.down_loading = false;
                    });
            }
        },
        // 点击分页当前页数
        currentChange(val) {
            this.page = val;
            //当分页发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['account_params']) {
                    newParamsList['account_params'].page = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        name: this.name,
                        code: this.code,
                        social_credit_code: this.social_credit_code,
                        alias_name: this.alias_name,
                        rid: this.rid,
                        huantong_code: this.huantong_code,
                        sf_code: this.sf_code,
                        parent_name: this.parent_name,
                        province_rid: this.province_rid,
                        identity_type: this.identity_type,
                        channel_type_code: this.channel_type_code,
                        channel_type_reference: this.channel_type_reference,
                        has_remark: this.has_remark,
                        confidence: this.confidence,
                        city_rid: this.city_rid,
                        city_name: this.city_name,
                        parent_rid: this.parent_rid,
                        type: this.type,
                        category_code: this.category_code,
                        sort: [this.data_name, this.sort]
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['account_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        // 切换每页条数
        sizeChange(val) {
            this.row = val;
            //当页数发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['account_params']) {
                    newParamsList['account_params'].row = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        name: this.name,
                        code: this.code,
                        social_credit_code: this.social_credit_code,
                        alias_name: this.alias_name,
                        rid: this.rid,
                        huantong_code: this.huantong_code,
                        sf_code: this.sf_code,
                        parent_name: this.parent_name,
                        province_rid: this.province_rid,
                        identity_type: this.identity_type,
                        channel_type_code: this.channel_type_code,
                        channel_type_reference: this.channel_type_reference,
                        has_remark: this.has_remark,
                        confidence: this.confidence,
                        city_rid: this.city_rid,
                        city_name: this.city_name,
                        parent_rid: this.parent_rid,
                        category_code: this.category_code,
                        type: this.type,
                        sort: [this.data_name, this.sort]
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['account_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        onDropChange(key, value) {
            this[key] = value;
        },
        //重置页面数据
        reset() {
            this.social_credit_code = '';
            this.alias_name = '';
            this.rid = '';
            this.huantong_code = '';
            this.sf_code = '';
            this.parent_name = '';
            this.name = '';
            this.province_rid = '';
            this.identity_type = '';
            this.channel_type_code = '';
            this.channel_type_reference = '';
            this.has_remark = '';
            this.confidence = '';
            this.city_rid = '';
            this.city_name = '';
            this.category_code = '';
            this.type = '';
            this.code = '';
            this.sort = '';
            this.data_name = '';
            this.page = 1;
            this.row = 25;
            var params = {
                page: 1,
                row: 25,
                sort: ['', ''],
                social_credit_code: '',
                alias_name: '',
                rid: '',
                huantong_code: '',
                sf_code: '',
                parent_name: '',
                name: '',
                province_rid: '',
                identity_type: '',
                channel_type_code: '',
                channel_type_reference: '',
                has_remark: '',
                confidence: '',
                city_rid: '',
                city_name: '',
                type: '',
                code: ''
            };
            var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            newParamsList['account_params'] = params;
            localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            this.$refs.identity_type_ref.reset();
            this.$refs.channel_type_code_ref.reset();
            this.$refs.channel_type_reference_ref.reset();
            this.$refs.has_remark_ref.reset();
            this.$refs.confidence_ref.reset();
            this.getList(0);
        }
    }
};
</script>
<style lang="scss" scoped>
.status_1 {
    color: green;
}
.status_2 {
    color: red;
}
</style>